import { AfterViewInit, Directive, Host } from '@angular/core';

import { TwcSelectComponent } from '@topcon/twc-angular';

/**
 * This directive fixes three issues. One caused by twc and other by webview2
 *
 * Issue  1:
 * - The goal is fixing an issue that appears on WinUI3 apps (Collage Site).
 * - The issue appears when the select is opened and the user click over an option,
 * - in that case the select is closed immediately and none option is selected
 * - (the blur function is executed first instead of the mousedown of TwcSelectOption).
 * - Fix: We add a timeout to leave time to execute selection behavior before the on blur
 *
 * Issue 2:
 * - The issue appears when trying to do a scroll with touch on an windows tablet
 * - 2.1 The on blur event on the twc-select closes the menu
 * - 2.2 If not it will be closed by the on mouse down event of the twc-select-option
 * - Fix 2.1: We add logic to detect if there is a mouse over or a touch has started
 * -- If a touch/mouseover has started we block the blur logic to close the menu
 * - Fix 2.2: On the option component we change the on mouse down event by an on click event.
 * -- That way an scroll attempt will not trigger the selection of an option closing the menu
 * -- Only a full click will select an option and close the menu
 * - Fix 2.3: Launching and releasing scroll with finger to scroll with momentum will close the menu
 * -- Code was added to disable on blur/focusout while scrolling
 *
 * Issue 3:
 * - We don’t know why the order of click and blur/focusout events differs between
 *   touch and mouse interactions.
 * - If a click happens and then a blur follows, the blur will close the
 *   menu that was just opened.
 * - It doesn’t make sense to trigger a blur immediately after opening the menu
 *   click, so we disable it in this case.
 */

// ! [ANGULAR_UPGRADE] Test and fix after angular upgrade

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'twc-select',
    standalone: false,
})
export class WinuiSelectFixDirective implements AfterViewInit {
    isMouseOverMenu = false;
    isTouching = false;
    isScrolling = false;

    constructor(@Host() private twcSelect: TwcSelectComponent) {}

    // We use focusout instead of blur to be able to inject our the behavior and skip theirs
    // @HostListener('focusout', ['$event'])
    // onFocusOut(event: FocusEvent): void {
    //     setTimeout(() => {
    //         this.isMouseOverMenu = !!this.twcSelect.optionsContainerRef?.nativeElement.matches(':hover');
    //         this.twcSelect.handleBlurAttempt(event);
    //     });
    // }
    // eslint-disable-next-line
    ngAfterViewInit(): void {
        // this.patchHandleBlurAttempt();
        // this.patchToggleOpeningAttempt();
        // this.patchOptionsContainerRef();
    }
    /**
     * Rewrites handleBlurAttempt function in TwcSelectComponent
     */
    // private patchHandleBlurAttempt(): void {
    //     const directive = this;
    //     // ! This function rewrite uses the current twc-select code and may break with future twc-select component updates.
    //     this.twcSelect.handleBlurAttempt = async function (this: TwcSelectComponent, event: FocusEvent): Promise<void> {
    //         // we block blur events as we are using focusout ones
    //         if (event.type === 'blur') {
    //             return;
    //         }

    //         // Values a little bit over the values used in our test just in case
    //         const delay = 300;
    //         const recentOpenLimit = 100;

    //         // see notes in patchToggleOpeningAttempt()
    //         const timeSinceLastOpen = Date.now() - ((this as any).lastOpened ?? 0);
    //         const isRecentlyOpen = timeSinceLastOpen < recentOpenLimit;

    //         if (this.isBlurHandlingAllowed) {
    //             if (isRecentlyOpen) {
    //                 return;
    //             }
    //             if (this.isBlurReason(event)) {
    //                 if (!this.isOpened) {
    //                     // This one doesn't have delay because if handleBlur() happens after toggleOpening()
    //                     // is going to close the menu again
    //                     this.handleBlur();
    //                 } else {
    //                     // We include a delay here to let mousedown actions execute before blur,
    //                     // and to let toggleOpening() run before blur to not reopen the menu
    //                     setTimeout(() => {
    //                         // Fixes close on scroll: We don't want to close the menu if a finger is touching or a mouse is over
    //                         if (!directive.isMouseOverMenu && !directive.isTouching && !directive.isScrolling) {
    //                             this.handleBlur();
    //                         }
    //                     }, delay);
    //                 }
    //             }
    //         } else {
    //             this.isBlurHandlingAllowed = true;
    //         }
    //     }.bind(this.twcSelect);
    // }

    /**
     * Patches toggleOpening to disable the blur action if there was
     * a recent assignment of isOpened = true triggered by a click event.
     */
    // private patchToggleOpeningAttempt(): void {
    //     this.twcSelect.toggleOpening = function (this: TwcSelectComponent): void {
    //         if (this.isOpened) {
    //             this.isOpened = false;
    //         } else if (!this.isDisabled) {
    //             this.isOpened = true;
    //             (this as any).lastOpened = Date.now();
    //         }
    //     }.bind(this.twcSelect);
    // }

    /**
     * Patches optionsContainerRef property in TwcSelectComponent with a setter
     * We need to detect when there is a new visible menu instance to add listeners to touch events
     * So we can set a flag if the menu is being touched or not
     */
    // private patchOptionsContainerRef(): void {
    //     const directive = this;
    //     let scrolling: ReturnType<typeof setTimeout>;

    //     // optionsContainerRef state initialized with current value
    //     let optionsContainerRef = this.twcSelect.optionsContainerRef;

    //     const onTouchStart = (): void => {
    //         directive.isTouching = true;
    //     };
    //     const onTouchEnd = (): void => {
    //         directive.isTouching = false;
    //     };
    //     const onScroll = (): void => {
    //         if (!directive.isScrolling) {
    //             directive.isScrolling = true;
    //         }

    //         clearTimeout(scrolling);
    //         scrolling = setTimeout(() => {
    //             this.isScrolling = false;
    //         }, 250);
    //     };

    //     Object.defineProperty(this.twcSelect, 'optionsContainerRef', {
    //         configurable: true,
    //         get: () => optionsContainerRef,
    //         set: (newOptionsContainerRef) => {
    //             // We add a setter to the optionsContainerRef in order to add the touch listeners when instantiated
    //             // We also handle listeners removal

    //             const oldElement = optionsContainerRef?.nativeElement;
    //             if (oldElement) {
    //                 oldElement.removeEventListener('touchstart', onTouchStart);
    //                 oldElement.removeEventListener('touchend', onTouchEnd);
    //                 oldElement.parentElement?.removeEventListener('scroll', onScroll);
    //             }
    //             const newElement = newOptionsContainerRef?.nativeElement;
    //             if (newElement) {
    //                 newElement.addEventListener('touchstart', onTouchStart);
    //                 newElement.addEventListener('touchend', onTouchEnd);
    //                 newElement.parentElement?.addEventListener('scroll', onScroll);
    //             }
    //             optionsContainerRef = newOptionsContainerRef;
    //         },
    //     });
    // }
}
